import { Navigate, Route } from "react-router";
import React from "react";
import { PageNotFound, SelectCompany } from "@/pages";

/**
 * Route definitions for error pages and catch-all routes.
 * Handles 404 errors and company selection errors.
 */
export const errorRoutes: React.ReactElement<any>[] = [
  <Route key="error-v3" path="/error/error-v3" element={<PageNotFound />} />,
  <Route
    key="select-company"
    path="/error/select-company"
    element={<SelectCompany />}
  />,
  <Route key="error-404" path="/error/error-v1" element={<PageNotFound />} />,
  <Route
    key="catchall"
    path="*"
    element={<Navigate to="/error/error-v1" replace={true} />}
  />,
];
